export default {"src":"/_next/static/media/holiday-promo-2023-news-hero.3efb9022.svg","height":150,"width":330,"blurWidth":0,"blurHeight":0};